'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaSliders = function FaSliders(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm10.9 31.4v2.9h-7.9v-2.9h7.9z m7.8-2.8q0.6 0 1 0.4t0.4 1v5.7q0 0.6-0.4 1t-1 0.4h-5.7q-0.6 0-1-0.4t-0.4-1v-5.7q0-0.6 0.4-1t1-0.4h5.7z m3.6-8.6v2.9h-19.3v-2.9h19.3z m-14.3-11.4v2.8h-5v-2.8h5z m29.3 22.8v2.9h-16.4v-2.9h16.4z m-21.4-25.7q0.5 0 1 0.4t0.4 1v5.8q0 0.5-0.4 1t-1 0.4h-5.8q-0.5 0-1-0.4t-0.4-1v-5.8q0-0.5 0.4-1t1-0.4h5.8z m14.2 11.4q0.6 0 1 0.5t0.5 1v5.7q0 0.6-0.5 1t-1 0.4h-5.7q-0.5 0-1-0.4t-0.4-1v-5.7q0-0.6 0.4-1t1-0.5h5.7z m7.2 2.9v2.9h-5v-2.9h5z m0-11.4v2.8h-19.3v-2.8h19.3z' })
        )
    );
};

exports.default = FaSliders;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/sliders.js
// module id = 531
// module chunks = 58411574672382 79611799117203 84521481881339 164655002686464